import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-input border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',

        // Soft, pastel status variants for consistent state coloring.
        neutral:
          'border-transparent bg-gray-100 text-gray-700 hover:bg-gray-100/80',
        warning:
          'border-transparent bg-amber-100 text-amber-800 hover:bg-amber-100/80',
        success:
          'border-transparent bg-green-100 text-green-800 hover:bg-green-100/80',
        danger:
          'border-transparent bg-red-100 text-red-800 hover:bg-red-100/80',
        info: 'border-transparent bg-sky-100 text-sky-800 hover:bg-sky-100/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
